import { useCreatorRewards } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
export const useGiveawayRewards = () => {
    const rewards = useCreatorRewards();
    return {
        rewards,
    };
};
